<template>
  <div class="main-layout">
    <CCollapseItem>
      <template slot="title-left"> 火车站点信息管理 </template>
      <template slot="body">
        <c-search
          v-model="pageParams"
          :searchItems="searchItems"
          @reset="refresh"
          @search="pageGet(true)"
        >
        </c-search>
      </template>
    </CCollapseItem>
    <el-card class="box-table box-bottom">
      <div slot="header" class="btn-group">
        <!-- 操作按钮 -->
        <div class="btn-left">
          <div class="opt-btn" title="新增" @click="goto('')">
            <i class="iconfont icon-add"></i>
          </div>
        </div>
        <!-- 右侧操作按钮 -->
        <table-btns
          :tableColumns="tableColumns"
          @tableColumnsChange="tableColumnsChange"
          @refresh="pageGet(true)"
        ></table-btns>
      </div>

      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        @selectionChange="selectionChange"
        @edit="goto"
        @delete="pageDel"
        v-loading="pageLoading"
      >
      </c-table>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div class="div-scroll" style="max-height: 550px; padding: 0 5%">
        <div v-loading="handleLoading">
          <c-form
            v-model="handleData"
            ref="cForm"
            :formRules="formRules"
            :formItems="formItems"
            @submit="submit"
            @resetFields="resetFields"
            labelWidth="120px"
          >
            <div slot="custom" v-if="titleType == 'edit'">
              <el-col :span="24">
                <el-form-item label="省份">
                  <el-input
                    v-model="handleData.province"
                    :disabled="isDisable"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="城市">
                  <el-input
                    v-model="handleData.city"
                    :disabled="isDisable"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="区县">
                  <el-input
                    v-model="handleData.area"
                    :disabled="isDisable"
                  ></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div slot="custom" v-if="titleType == 'add'">
              <el-form-item label="所在地" prop="region">
                <el-cascader
                  style="width: 100%"
                  v-model="handleData.region"
                  :options="sysAreaOptions"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'code',
                    children: 'sysAreaLists',
                  }"
                ></el-cascader>
              </el-form-item>
            </div>
          </c-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/welcomesite";
let mPage = MPage({
  pagePath: "/account/train-station-info/listPage",
  pageDelPath: "/account/train-station-info",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "/account/train-station-info",
  handleInsertPath: "/account/train-station-info/save",
  handleUpdatePath: "/account/train-station-info/update",
  handleDownLoadPath: "",
  handleData: {},
});
export default {
  mixins: [mPage, mHandle],
  name: "",
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      isDisable: true,
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules,
      idList: [],
      sysAreaOptions: [],
      title: "",
      dialogFormVisible: false,
      dialogType: "form",
      titleType: "add",
      defaultHandleData: {
        name: "",
        isStartStation:'',
        region: [],
      },
    };
  },
  created() {
    this.getSysAreaList();
    this.SUCCESS_CODE = this.$store.state.dic.SUCCESS_CODE;
    this.handleData = Object.assign({}, this.defaultHandleData);
  },
  mounted() {},
  methods: {
    getSysAreaList() {
      this.$http
        .get("/account/sys-area/getSysAreaList")
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            this.sysAreaOptions = res.data[0].sysAreaLists;
            console.log(this.sysAreaOptions);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },

    goto(data) {
      this.dialogFormVisible = true;
      this.handleData = Object.assign({}, this.defaultHandleData);
      let id = data.id;
      if (id) {
        this.handleGet(id);
        this.titleType = "edit";
        this.title = "编辑站点信息";
      } else {
        this.titleType = "add";
        this.title = "新增站点信息";
      }
    },
    selectionChange(data) {
      let idList = [];
      if (data.length) {
        data.forEach((item) => {
          idList.push(item.id);
        });
        this.idList = idList;
      }
    },
    handleDelBatch() {
      if (this.idList.length) {
        this.pageDels(this.idList);
      } else {
        this.$message({
          message: "请选择需要删除的数据！",
          type: "warning",
        });
      }
    },
    pageDelAfterFn() {
      this.idList = [];
      this.pageGet(true);
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    submit() {
      if (this.handleData.id) {
        this.handleUpdate();
      } else {
        this.handleInsert();
      }
    },
    handleAfterFn() {
      this.$refs.cForm.resetFields();
      this.dialogFormVisible = false;
      this.pageGet(true);
    },
    resetFields() {
      this.dialogFormVisible = false;
    },
    handleDialogClose() {
      this.$refs.cForm.resetFields();
    },
  },
};
</script>
